import { render, staticRenderFns } from "./recognition.vue?vue&type=template&id=6b4ef8db&"
import script from "./recognition.vue?vue&type=script&lang=js&"
export * from "./recognition.vue?vue&type=script&lang=js&"
import style0 from "./recognition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports